/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import { Text, Theme, BlockRow, Modal, Loader, TextInput } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import IconButton from "@mui/material/IconButton";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import Menu from "@mui/material/Menu/Menu";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import { styled } from '@mui/system';
import { reassignPendingManual } from '../../../actions/adjudication.js';
import { connect } from 'react-redux';
import PermissionsComponent from '../../../components/PermissionsComponent.js';

const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
        borderRadius: 8,
        minWidth: 240
    }
});

/**
 * @param uid
 * @param type
 * @param isDependent
 * @param status
 * @param payee
 * @param patient
 * @param numProcedures
 * @param submissionDate
 * @param isHeader
 * @param setNeedsMoreInformation
 * @param handleDeletePendingClaim
 * @param styles
 * @param testid
 * @returns {JSX.Element}
 * @constructor
 */
const ManualTransactionBlock = (props) => {
    const {
        uid, 
        type, 
        isDependent, 
        status, 
        payee, 
        patient, 
        numProcedures, 
        submissionDate, 
        isHeader, 
        testid,
        assignedTo,
        dateAssigned,
        adjudicators,
        setReassignedClaim,
        handleDeletePendingClaim,
        setNeedsMoreInformation,
        loader,
        masterLoading
    } = props;

    const [ anchorEl, setAnchorEl ] = useState(null);
    const [ showReassign, setShowReassign ] = useState(false);
    const [ assignTo, setAssignTo ] = useState(null);

    const styles = {
        headerBlockRow: {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            flexDirection: 'row',
            height: 30,
            marginBottom: 5
        },
        typeBlock: {
            display: 'flex',
            flex: 1,
            alignItems: 'flex-start',
            backgroundColor: Theme.colors.lightBlue,
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            padding: "0 20px"
        },
        block: {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
        }
    };

    const _handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const _handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const _openClaim = () => {
        if (assignedTo === `${ props.master.firstname } ${ props.master.lastname }` || props.accessType.toUpperCase() === 'MASTER') {
            window.location.href = `/adjudication/simplyDental/${ type }/null/null/${ uid }`;
            return null;
        }

        return null;
    };

    const _reassign = async () => {
        const success = await props.dispatch(reassignPendingManual(props.ediClaimID, assignTo.masterID));        
        if (success) {
            setReassignedClaim(props.ediClaimID, assignTo.masterID);
            setShowReassign(false);
        }
    };

    const _toggleReassign = () => {
        setShowReassign(!showReassign);
    };
    
    const _closeModal = () => {
        setShowReassign(false);
    };

    /**
     * 
     * @param {*} value 
     */
    const setAdjudicator = (value) => {
        const adjudicator = adjudicators.find((item) => `${ item.firstname } ${ item.lastname }` === value);
        setAssignTo(adjudicator);
    };

    if (isHeader) {
        return (
            <div style={styles.headerBlockRow}>
                <div style={{ ...styles.typeBlock, backgroundColor: Theme.colors.backgroundGrey, padding: "0 15px" }}>
                    <Text small>Type</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Dependent Claim</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Payee</Text>
                </div>

                <div style={styles.block}>
                    <Text small># Procedures</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Identifier (Temporary)</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Status</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Submission Date</Text>
                </div>

                <div style={styles.block}>
                    <Text small>Assigned To</Text>
                </div>
                
                <div style={styles.block}>
                    <Text small>Assigned Date</Text>
                </div>

                <div style={{ ...styles.block, flex: 0.5 }}/>
            </div>
        );
    }

    return (
        <React.Fragment>
            <BlockRow id={testid}>
                <div style={styles.typeBlock} onClick={ _openClaim }>
                    <Text medium light>{ type.charAt(0).toUpperCase() + type.slice(1) }</Text>
                    <Text tiny>
                        { patient }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { isDependent ? 'Yes' : 'No' }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { payee ? payee.charAt(0).toUpperCase() + payee.slice(1) : 'N/A' }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { numProcedures }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text small light>
                        { uid }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { status }
                    </Text>
                </div>

                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { dates.getLocalDisplay(submissionDate) }
                    </Text>
                </div>
                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { assignedTo }
                    </Text>
                </div>
                <div style={styles.block} onClick={ _openClaim }>
                    <Text medium light>
                        { dates.getLocalDisplay(dateAssigned) }
                    </Text>
                </div>

                <div style={{ ...styles.block, flex: 0.5 }}>
                    <IconButton aria-label="Edit" onClick={_handleMenuClick} sx={{ color: Theme.colors.darkGrey }}>
                        <MoreVertIcon />
                    </IconButton>

                    <StyledMenu
                        anchorEl={ anchorEl }
                        open={ Boolean(anchorEl) }
                        onClose={_handleCloseMenu}
                        disableAutoFocusItem={true}
                        anchorOrigin={ { vertical: "top", horizontal: "left" } }
                    >
                        <MenuItem onClick={ () => {
                            _handleCloseMenu();
                            setNeedsMoreInformation(uid);
                        }}>
                            <Text color="inherit" medium display="inline">
                                Needs more information
                            </Text>
                        </MenuItem>

                        <PermissionsComponent
                            permission="Reassign Claim"
                            accessType={ props.accessType }
                            level="write"
                        >

                            <MenuItem onClick={ () => {
                                _toggleReassign();
                                _handleCloseMenu();
                            }}>
                                <Text color="inherit" medium display="inline">
                                Reassign
                                </Text>
                            </MenuItem>
                        </PermissionsComponent>

                        <PermissionsComponent
                            permission="Remove Pending EDI Transaction"
                            accessType={props.accessType }
                            level="write"
                        >
                            <MenuItem onClick={ () => {
                                handleDeletePendingClaim(uid);
                                _handleCloseMenu();
                            }}>
                                <Text color="inherit" medium display="inline">
                                    Remove
                                </Text>
                            </MenuItem>
                        </PermissionsComponent>
                    </StyledMenu>
                </div>
            </BlockRow>

            <Modal
                open={ showReassign }
                onClose={ _closeModal }
                title="Reassign Adjudicator"
                primaryButton={{
                    label: "Reassign",
                    onClick: _reassign
                }}
                loader={ loader }
            >
                {
                    loader?.isLoading || masterLoading ?
                        <Loader isContainer/>
                        :
                        <div>
                            <Text
                                align="left"
                                medium
                                display="inline-block"
                                margin="10px 0"
                            >
                                    Reassign this claim to a different adjudicator by selecting an option from the list below.
                            </Text>

                            <TextInput
                                label="Current Adjudicator"
                                value={ assignedTo }
                                disabled
                                fullWidth
                                variant="outlined"
                                select
                                selectOptions={ [ "Unassigned", ...props.adjudicators.map((item) => `${ item.firstname } ${ item.lastname }`) ] }
                            />

                            <TextInput
                                label="New Adjudicator"
                                fullWidth
                                value={ assignTo ? `${ assignTo.firstname } ${ assignTo.lastname }` : `Unassigned` }
                                variant="outlined"
                                onChange={(e) => setAdjudicator(e.target.value)}
                                select
                                selectOptions={ props.adjudicators.map((item) => `${ item.firstname } ${ item.lastname }`) }
                            />
                        </div>
                }
            </Modal>
        </React.Fragment>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    adjudicators: state.master.adjudicators,
    accessType: state.master.access,
    masterID: state.master.masterID,
    master: state.master

});

export default connect(mapStateToProps)(ManualTransactionBlock);